import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const SideBarContainer = styled('div')<{
    isLargeScreen: boolean
    theme?: TTheme
}>`
    position: ${({ isLargeScreen }) => (isLargeScreen ? 'fixed' : 'static')};
    background: ${({ theme }) => theme.colors.semantic.sideBarBackground};
    grid-area: side;
    height: 100vh;
    padding: 0px 20px;
    display: flex;
    flex-direction: column;
    overflow: auto;
    border-right: 1px solid ${({ theme }) => theme.colors.semantic.headerBorder};
    z-index: 100;
`

export const IconContainer = styled('div')`
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 20px;
`
